// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"w_h","cross":"w_9","crossIcon":"w_bb"};